/**
 * 常量定义
 */

export const SORT_ASC_TEXT = '点击升序';
export const SORT_DES_TEXT = '点击降序';
export const SORT_CANCEL_TEXT = '取消排序';

export const FILTER_TRIGGER_BTN_TEXT = '确定';
export const FILTER_TRIGGER_REST_TEXT = '重置';
export const FILTER_TIP_TEXT = '过滤器';

export const SUMMARY_TOTAL_TEXT = '合计';

export const DEFAULT_PAGE_SIZE = 10; // 默认每页数据
export const DEFAULT_PAGE_SIZE_TWENTY = 20; // 默认每页数据
export const DEFAULT_CURRENT_PAGE = 1; // 默认页码
